/** @jsxImportSource theme-ui */
import React from 'react';
import { List } from 'semantic-ui-react';

import * as dto from 'client/dto';
import { sxtheme } from 'utils/cssHelpers';
import { formatDate, formatDateUntilToday } from 'utils/dateTimeHelpers';

import { Typography } from 'components/_common/Typography';

const stripLastPeriod = s => (!s ? s : s.replace(/\.+$/, ''));

type ReferenceListProps = {
  timeframeStartDate: Date;
  articles: dto.ArticleModel[];
};

const ReferenceList: React.FC<ReferenceListProps> = ({ timeframeStartDate, articles }) => {
  return (
    <List className="xunpadded">
      <List.Item>
        <Typography inline variant="body2" color="stone90">
          References used between&nbsp;
        </Typography>
        <Typography inline variant="subtitle1" color="stone90">
          {formatDateUntilToday(timeframeStartDate)}:
        </Typography>
      </List.Item>
      {articles.map((article, index) => (
        <List.Item key={index}>
          <ReferenceListItem {...article} />
        </List.Item>
      ))}
    </List>
  );
};

export default ReferenceList;

export const ReferenceListItem: React.FC<dto.ArticleModel> = ({
  url,
  title,
  publishedDate,
  sourceName,
}) => {
  return (
    <div sx={{ lineHeight: '20px' }}>
      <a href={url} target="_blank" rel="noopener noreferrer">
        <Typography
          variant="body2"
          color="deepSea70"
          inline
          sx={{
            textDecoration: 'underline',
            '&:hover': {
              color: sxtheme(t => t.colors.sea90),
            },
          }}
        >
          {stripLastPeriod(title)}
        </Typography>
      </a>
      <Typography variant="body2" color="deepSea70" inline>
        .&nbsp;
        {formatDate(publishedDate)}.
      </Typography>
      <Typography variant="overline" color="deepSea70" inline>
        {' '}
        {sourceName}.
      </Typography>
    </div>
  );
};
